import { supabase } from "@/lib/supabase";
import { ChatHistoryRecord } from "@/types/history";

class ChatHistoryService {
  getChatHistoryBySessionId = async (sessionId: string): Promise<ChatHistoryRecord[]> => {
    const { data, error } = await supabase
      .from("session_chat_histories")
      .select<"*", ChatHistoryRecord>("*")
      .eq("session_id", sessionId)
      .order("id", { ascending: true });

    if (error) throw error;
    return data;
  };
}

export const chatHistoryService = new ChatHistoryService();
